module.exports = __webpack_public_path__ + "img/right_arrow.62bba65b.svg";